import type { SyntheticEvent } from 'react'

import { InlineBackAngleWithTitle } from "/app/libraries/arcana/src/atoms/Button/Templates/index.ts"

import { useUnit } from 'effector-react'
import { model as router } from '~/core/router'
import { translations } from '../model'

export const BackButton = () => {
  const formTranslations = useUnit(translations.$verifyFormTranslation)
  const onGoBack = (e: SyntheticEvent) => {
    e.preventDefault()
    e.stopPropagation()
    router.navigateBack()
  }
  return (
    <InlineBackAngleWithTitle
      title={formTranslations.back}
      onClick={onGoBack}
    />
  )
}
